import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import StyledCardBackground from './StyledCardBackground';

const CardBackground = ({children = null, className = null, ...rest}) => {
	const props = {
		...rest,
		className: classNames('card-background', {[className]: !!className})
	};

	return <StyledCardBackground {...props}>{children && children}</StyledCardBackground>;
};

CardBackground.propTypes = {
	className: PropTypes.string
};

export default CardBackground;
